import { Package } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { AdminTab } from '.';
import { useGetLifeglovLinerStocksQuery } from '../../api/lifeglov-liner-stock';
import { useAuthentication } from '../../auth';
import { Button } from '../../components/Button';
import { DataTable } from '../../components/DataTable';
import { DialogTrigger } from '../../components/Dialog';
import { TabsList, TabsTrigger } from '../../components/Tabs';
import { useTenantIds } from '../../hooks/useTenantIds';
import { OrderLifeglovLinerStockDialog } from '../components/OrderLifeglovLinerStockDialog';
import { useLifeglovLinerStockColumns } from '../hooks/useLifeglovLinerStockColumns';

export function LifeglovLinerStockList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const shouldOpenOrderDialog = searchParams.get('action') === 'order';
  const currentUser = useAuthentication();
  const tenantIds = useTenantIds();
  const subtenantIds = currentUser?.subtenants
    ?.filter((s) => !tenantIds || tenantIds.includes(s.name))
    .map((s) => s.id);

  const { data: stocks, isLoading } = useGetLifeglovLinerStocksQuery({ subtenantIds });
  const columns = useLifeglovLinerStockColumns();

  return (
    <>
      <div className="flex flex-1 flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
        <TabsList className="grid w-full grid-cols-3 md:w-[600px]">
          <TabsTrigger value={AdminTab.Users}>Users</TabsTrigger>
          <TabsTrigger value={AdminTab.Clinics}>Clinics</TabsTrigger>
          <TabsTrigger value={AdminTab.LifeglovLinerStock}>Liner Stock</TabsTrigger>
        </TabsList>

        <OrderLifeglovLinerStockDialog
          defaultOpen={shouldOpenOrderDialog}
          onOpenChange={(open) => {
            if (!open && shouldOpenOrderDialog) {
              setSearchParams((params) => {
                params.delete('action');
                return params;
              });
            }
          }}
        >
          <DialogTrigger asChild>
            <Button icon={Package}>Request Refill</Button>
          </DialogTrigger>
        </OrderLifeglovLinerStockDialog>
      </div>

      <div className="overflow-auto">
        <DataTable
          rows={stocks ?? []}
          columns={columns}
          pageSize={10}
          isLoading={isLoading}
          stickyHeader
          initialSorting={[{ id: 'available', desc: false }]}
          className="mt-4 min-w-[400px]"
          testId="lifeglov-liner-stock-list"
        />
      </div>
    </>
  );
}
